import { Component } from '@angular/core';
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-token-expired-restart',
    imports: [
        ColoredBackgroundComponent,
        FinishBoxComponent,
        FooterComponent
    ],
  templateUrl: './token-expired-restart.component.html',
  styleUrl: './token-expired-restart.component.css'
})
export class TokenExpiredRestartComponent {
  constructor(public locale:LocaleService) {
  }
}
